<div class="ideals-skeleton" [class]="styleClass" [ngStyle]="{ width, height }"></div>
